import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import Quote from '../../../components/Quote';
import props from '../../../lib/contentLayoutProps/the-kingston-difference/layoutProps';
import styles from './index.module.scss';

import cheryl from './cheryl.jpg';
import gladys from './gladys.jpg';
import kylie from './kylie.jpg';
import queenie from './queenie.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="alumni-testimonials">
    <h1>校友分享</h1>
    <div className={styles.quote}>
      <div className={styles.person}>
        <div className={styles.photo} style={{ backgroundImage: `url(${cheryl})` }} />
        <div className={styles.cite}>
          <div className={styles.name}>丁繼翹</div>
          <div className={styles.classOf}>二零一三年畢業生</div>
        </div>
      </div>
      <Quote className={styles.text}>
        <p>我於二零零五年至二零一三年間就讀京斯敦，並於京斯敦國際學校畢業。</p>
        <p>
          京斯敦不但把我塑造成一位學習者，並成就了今天的我。我學習成為一位具責任心、上進的人，管理好時間及照料好自己、並常常關心及體諒身邊的人、無論在校內或校外，我都能在群體中作主導，帶領大家作正面的改變(我仍未忘記我曾代表班級寫信給馬拉拉·優素福扎伊)。我不會忘記(幾乎)每個月都需提交的國際文憑學生反思：說實話，我並不喜歡做這些反思，但回望過去，這些反思正正能讓我學習團體合作、明白溝通的重要性、創造力的價值、多元化的好處、團結的力量等。在此，我用筆墨也未能道出我對這裡所學所聞的感恩之心，這一切令我變得更完整，幫助我渡過無數難關，這一切是當時年幼而脆弱的我從沒想像過的。
        </p>
        <p>
          京斯敦的教育模式與別不同。考察活動、實驗、專題研習及各類型活動為我帶來獨特的學習體驗，加上在國際文憑小學課程理念的熏陶下，我培養了非常重要的學習習慣，時常秉持正面熱誠的學習態度，而這比取得好成績來得重要，因為這是伴隨我們一生的特質，直至長大成人後，我們依然保持活到老，學到老的態度。
        </p>
        <p>
          於京斯敦完成小學生涯並畢業對我而言是非常艱巨的——我一直以來都與二十多位同班同學為伍，想到大家即將分道揚鑣，實在使人感到依依不捨。入讀漢基國際學校後，雖然經常聽到別人的讚美之言，但亦無法停止我渴望乘坐時光機，回到兩年前於京斯敦再次享受快樂時光的想法。然而，我亦會很高興地說，即使五年已過去，大家其實也並沒有真正離開——我們的精神和力量，以及對彼此的愛護依然可以從我們每天於社交媒體上或每次聚會的交流中流露出來。相比其他學校，京斯敦雖是小型社區，但正因如此師生間才能建立強大親密的關係。
        </p>
        <p>
          直到現在，我依然非常感激京斯敦幫助我裝備好自己，學習國際文憑中學課程，並準備修讀國際文憑大學預科課程。我亦非常感謝京斯敦帶給我無數珍貴的回憶。
        </p>
      </Quote>
    </div>

    <div className={styles.quote}>
      <div className={styles.person}>
        <div className={styles.photo} style={{ backgroundImage: `url(${gladys})` }} />
        <div className={styles.cite}>
          <div className={styles.name}>郭盈希</div>
          <div className={styles.classOf}>二零一七年畢業生</div>
        </div>
      </div>
      <Quote className={styles.text}>
        <p>
          我非常感謝及感激京斯敦為我所做的一切。回想過去的時光，我才發現京斯敦並不是一所普通的學校。這是一所充滿歡笑聲與喜樂的學校，在我心中有著不可取代的位置。我從二年級開始便在這裡就讀，因此它對我意義重大，就好像我第二個家一樣。感謝京斯敦將我塑造成今天的我，以及它帶給我的珍貴回憶和成就。即使現在已經升上中學，我還是經常回想過去在京斯敦的快樂時光——我們在春季音樂會上表演音樂劇《擊劍大賽》、西安海外考察之旅、不同的戶外考察活動、六年級畢業展覽(我們組的主題是「貧窮與露宿問題」)、五年級宿營之旅，以及由我當主持的畢業典禮等等。能在這裡成長，並與優秀的老師和同學一起學習，實在是非常美好的事。而當畢業之期越來越接近，想到即將要和一起並肩學習多時的好友離別，我便感到越來越難過。我多希望能繼續在京斯敦小學讀書，永遠不離開！但我也知道這永遠無法實現，因為人生總要繼續向前。我們要探索自己未來的道路，追尋自己的夢想。但是無論如何，我都不會忘記京斯敦的教誨，過去我所付出過的努力，將來一定會有回報。
        </p>
      </Quote>
    </div>

    <div className={styles.quote}>
      <div className={styles.person}>
        <div className={styles.photo} style={{ backgroundImage: `url(${kylie})` }} />
        <div className={styles.cite}>
          <div className={styles.name}>王禹心</div>
          <div className={styles.classOf}>二零一七年畢業生</div>
        </div>
      </div>
      <Quote className={styles.text}>
        <p>
          我衷心感謝京斯敦對我的栽培。現在回想起來，我才發現六年時光轉眼即逝。雖然時間看似短暫，但全賴京斯敦將我塑造成今天的我。京斯敦對我而言意義重大——它是我第二個家，所有同學們和老師們就像一個大家庭。我在這裡擁有許多難忘的回憶。從戶外考察、宿營之旅、海外考察、春季音樂會，到年終的畢業成果展……
          京斯敦帶我們踏足每個可以學習的角落。你無法想像當我終於要離開這所學校時，心裡是多麼的難過及不捨。京斯敦教育和指導我們多元發展，教我們即使畢業後也要繼續努力循自己的方向努力成長，到無人涉足過的地方探索。將來，當有人問起，我必自豪地告訴他們：我在京斯敦國際學校度過了美好的六年。
        </p>
      </Quote>
    </div>

    <div className={styles.quote}>
      <div className={styles.person}>
        <div className={styles.photo} style={{ backgroundImage: `url(${queenie})` }} />
        <div className={styles.cite}>
          <div className={styles.name}>陳子翹</div>
          <div className={styles.classOf}>二零一七年畢業生</div>
        </div>
      </div>
      <Quote className={styles.text}>
        <p>
          我衷心感謝京斯敦對我的栽培。我經常回想起自己在京斯敦的日子裡做過的事，以及它如何改變我、導我向善。京斯敦對我的意義重大，是我不可分割的一部分。猶記得四年級時，我跟朋友一起就海洋污染議題採取行動，以及向所有高年級師生匯報，這是我最美好、最難忘的經歷之一……
          在校的六年時光裡，我結交了很多好朋友，亦認識了許多出色的老師。雖然六年稍縱即逝，但他們對我而言是十分重要的。沒有他們，絕不可能成就今天的我。同時，我也在京斯敦留下了許多美好的回憶和重大的成就，亦曾面對許多不同的困難和挑戰。還有到不同地方探索的戶外考察、五年級宿營之旅、大大小小的小組研習、成果展、運動會、春季音樂會、六年級海外考察之旅和非常重要的畢業成果展。畢業成果展在六年級舉行，隨着在校時間越來越接近尾聲，想到即將要離開多年來伴隨我們成長的同伴、學校、老師，以及所有我們熟悉的事物，大家都感到非常難過。但這就是人生，是我們在成長路上必須邁出的一步。我們必須繼續人生的旅程，與此同時謹記京斯敦在過去六年帶給我們的回憶、經歷和知識。我堅信，終有一天，我們會在旅途上再次相遇。
        </p>
      </Quote>
    </div>
  </ContentLayout>
);
